import { isPublicContPath } from '~/utils/auth-routing'

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return
  if (!/\/admin(\/|$)/.test(to.path)) return
  if (/\/admin\/setup(\/|$)/.test(to.path)) return
  if (/\/admin\/abonament(\/|$)/.test(to.path)) return
  if (isPublicContPath(to.path)) return

  const authStore = useAuthStore()
  const { fetchUser } = useAuth()
  authStore.hydrateFromStorage()
  if (!authStore.user) {
    await fetchUser()
  }
  if (!authStore.isAdmin) return

  const { pending, refresh } = useSetupWizard()
  if (pending.value === null) {
    await refresh()
  }
  if (pending.value === true) {
    const shopPath = useShopPath()
    return navigateTo(shopPath('/admin/setup'))
  }
})
